import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import 'css-loader/dist/runtime/api.js'
import 'vue-style-loader/lib/addStylesShadow'
import 'vue-loader/lib/runtime/componentNormalizer'

window.customElements.define('wc-comparison-table', wrap(Vue, () => import('~root/src/tools/comparison-table.vue?shadow')))

window.customElements.define('wc-investment-example', wrap(Vue, () => import('~root/src/tools/investment-example.vue?shadow')))

window.customElements.define('wc-lazy-image', wrap(Vue, () => import('~root/src/tools/lazy-image.vue?shadow')))

window.customElements.define('wc-price-card-chart-alt', wrap(Vue, () => import('~root/src/tools/price-card-chart-alt.vue?shadow')))

window.customElements.define('wc-price-card-chart-b', wrap(Vue, () => import('~root/src/tools/price-card-chart-b.vue?shadow')))

window.customElements.define('wc-price-card-chart', wrap(Vue, () => import('~root/src/tools/price-card-chart.vue?shadow')))

window.customElements.define('wc-price-card', wrap(Vue, () => import('~root/src/tools/price-card.vue?shadow')))

window.customElements.define('wc-price-chart-pill', wrap(Vue, () => import('~root/src/tools/price-chart-pill.vue?shadow')))

window.customElements.define('wc-price-difference-status', wrap(Vue, () => import('~root/src/tools/price-difference-status.vue?shadow')))

window.customElements.define('wc-price-historic-chart-alt', wrap(Vue, () => import('~root/src/tools/price-historic-chart-alt.vue?shadow')))

window.customElements.define('wc-price-historic-chart', wrap(Vue, () => import('~root/src/tools/price-historic-chart.vue?shadow')))

window.customElements.define('wc-price-table', wrap(Vue, () => import('~root/src/tools/price-table.vue?shadow')))

window.customElements.define('wc-price-ticker', wrap(Vue, () => import('~root/src/tools/price-ticker.vue?shadow')))

window.customElements.define('wc-stock-card-alt', wrap(Vue, () => import('~root/src/tools/stock-card-alt.vue?shadow')))

window.customElements.define('wc-stock-card', wrap(Vue, () => import('~root/src/tools/stock-card.vue?shadow')))